<h3>{{ task.type?.name }}</h3>

<p>

  <b>Inicio:</b> {{ task.startTimestamp?.toDate() | date:'dd/MM/yyyy, HH:mm' }} <img src="assets/dot-inicio.svg" width="18" height="27" style="vertical-align:middle; margin-right:4px" alt="Inicio">
</p>
<p>

  <b>Fin:</b> {{ task.finishTimestamp?.toDate() | date:'dd/MM/yyyy, HH:mm' }} <img src="assets/dot-fin.svg" width="18" height="27" style="vertical-align:middle; margin-right:4px" alt="Fin">
</p>

<p><b>Indicaciones:</b> {{ task.instructions }}</p>
<p><b>Resultado:</b> {{ task.result }}</p>
<p><b>Comentario:</b> {{ task.comments }}</p>

<!-- MAPA -->
<lib-ng-visor-sigpac #visor centermap="-5.6954768,40.9670626"></lib-ng-visor-sigpac>
